export type RoleType = {
  _id: string;
  role: string;
  datasets: string[];
  permissions: string[];
};

export enum RolesAction {
  REPLACE_ROLES = "REPLACE_ROLES",
  ADD_ROLE = "ADD_ROLE",
  UPDATE_ROLE = "UPDATE_ROLE",
  DELETE_ROLE = "DELETE_ROLE",
}

interface ReplaceRoles {
  type: RolesAction.REPLACE_ROLES;
  roles: RoleType[];
}
interface AddRole {
  type: RolesAction.ADD_ROLE;
  role: RoleType;
}
interface UpdateRole {
  type: RolesAction.UPDATE_ROLE;
  role: RoleType;
}
interface DeleteRole {
  type: RolesAction.DELETE_ROLE;
  roleId: string;
}

export type RolesActionTypes = ReplaceRoles | AddRole | UpdateRole | DeleteRole;
